import axiosInstance from '@/core/js/interceptor';
import { AuthService } from './AuthService';

export const CommonService = {
    getBranch: (data) =>
        axiosInstance.post(
            '/api/common/getBranch',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    pendingVoucherApprovalCounter: (data) =>
        axiosInstance.post(
            '/api/common/pendingVoucherApprovalCounter',
            {
                branch_id: AuthService.getActiveBranchId(),
                user_id: AuthService.getActiveUserId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    pendingVoucherApprovalList: (data) =>
        axiosInstance.post(
            '/api/common/pendingVoucherApprovalList',
            {
                branch_id: AuthService.getActiveBranchId(),
                user_id: AuthService.getActiveUserId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    updateVoucherApprovalStage: (data) =>
        axiosInstance.post(
            '/api/common/updateVoucherApprovalStage',
            {
                branch_id: AuthService.getActiveBranchId(),
                user_id: AuthService.getActiveUserId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProvinces: (data) =>
        axiosInstance.post(
            '/api/common/getProvinces',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyGroups: (data) =>
        axiosInstance.post(
            '/api/common/getPartyGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartySpecialDiscountGroup: (data) =>
        axiosInstance.post(
            '/api/common/getPartySpecialDiscountGroup',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartySpecialDiscountApplicable: (data) =>
        axiosInstance.post(
            '/api/common/getPartySpecialDiscountApplicable',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyTypes: (data) =>
        axiosInstance.post(
            '/api/common/getPartyTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getWarehouseType: (data) =>
        axiosInstance.post(
            '/api/common/getWarehouseType',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyGrades: (data) =>
        axiosInstance.post(
            '/api/common/getPartyGrades',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyFbrStatus: (data) =>
        axiosInstance.post(
            '/api/common/getPartyFbrStatus',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyAddaBilty: (data) =>
        axiosInstance.post(
            '/api/common/getPartyAddaBilty',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeCategory: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeCategory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeDesignations: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeDesignations',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeGrade: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeGrade',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeGender: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeGender',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeMaritalStatus: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeMaritalStatus',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeReligion: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeReligion',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeBloodGroup: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeBloodGroup',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeBank: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeBank',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSalesman: (data) =>
        axiosInstance.post(
            '/api/common/getSalesman',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployee: (data) =>
        axiosInstance.post(
            '/api/common/getEmployee',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSalesDesingationHierarchy: (data) =>
        axiosInstance.post(
            '/api/common/getSalesDesingationHierarchy',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getTowns: (data) =>
        axiosInstance.post(
            '/api/common/getTowns',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getCities: (data) =>
        axiosInstance.post(
            '/api/common/getCities',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getUsers: (data) =>
        axiosInstance.post(
            '/api/common/getUsers',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyMaxCode: (data) =>
        axiosInstance.post(
            '/api/common/getPartyMaxCode',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountOpeningBalance: (data) =>
        axiosInstance.post(
            '/api/common/getAccountOpeningBalance',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSalesPriceList: (data) =>
        axiosInstance.post(
            '/api/common/getProductSalesPriceList',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductLastSalesOrderRate: (data) =>
        axiosInstance.post(
            '/api/common/getProductLastSalesOrderRate',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductStockByWarehouse: (data) =>
        axiosInstance.post(
            '/api/common/getProductStockByWarehouse',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductStockByLotno: (data) =>
        axiosInstance.post(
            '/api/common/getProductStockByLotno',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductOpeningBalance: (data) =>
        axiosInstance.post(
            '/api/common/getProductOpeningBalance',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductTypes: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductCategories: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductCategories',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductGroups: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductSubGroups: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductSubGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductUnits: (data) =>
        axiosInstance.post(
            '/api/common/getProductUnits',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getWarehouseRows: (data) =>
        axiosInstance.post(
            '/api/common/getWarehouseRows',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductTypesByParams: (data) =>
        axiosInstance.post(
            '/api/common/getProductTypesByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductGroups: (data) =>
        axiosInstance.post(
            '/api/common/getProductGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSubGroups: (data) =>
        axiosInstance.post(
            '/api/common/getProductSubGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAssetClassification: (data) =>
        axiosInstance.post(
            '/api/common/getAssetClassification',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAssetGroup: (data) =>
        axiosInstance.post(
            '/api/common/getAssetGroup',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAssetSubGroup: (data) =>
        axiosInstance.post(
            '/api/common/getAssetSubGroup',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProfitCenters: (data) =>
        axiosInstance.post(
            '/api/common/getProfitCenters',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getCostCenters: (data) =>
        axiosInstance.post(
            '/api/common/getCostCenters',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSubCostCentersType: (data) =>
        axiosInstance.post(
            '/api/common/getSubCostCentersType',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSubCostCenters: (data) =>
        axiosInstance.post(
            '/api/common/getSubCostCenters',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSubCostCentersList: (data) =>
        axiosInstance.post(
            '/api/common/getSubCostCentersList',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductCableTypeByCenters: (data) =>
        axiosInstance.post(
            '/api/common/getProductCableTypeByCenters',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductCableType: (data) =>
        axiosInstance.post(
            '/api/common/getProductCableType',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductBrands: (data) =>
        axiosInstance.post(
            '/api/common/getProductBrands',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductShape: (data) =>
        axiosInstance.post(
            '/api/common/getProductShape',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductConductorShape: (data) =>
        axiosInstance.post(
            '/api/common/getProductConductorShape',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSteelWireSize: (data) =>
        axiosInstance.post(
            '/api/common/getProductSteelWireSize',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductCoreCount: (data) =>
        axiosInstance.post(
            '/api/common/getProductCoreCount',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductConductor: (data) =>
        axiosInstance.post(
            '/api/common/getProductConductor',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSheatingMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getProductSheatingMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductConstruction: (data) =>
        axiosInstance.post(
            '/api/common/getProductConstruction',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductCableOuterDia: (data) =>
        axiosInstance.post(
            '/api/common/getProductCableOuterDia',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductCategory: (data) =>
        axiosInstance.post(
            '/api/common/getProductCategory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductShielding: (data) =>
        axiosInstance.post(
            '/api/common/getProductShielding',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductConductorDia: (data) =>
        axiosInstance.post(
            '/api/common/getProductConductorDia',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductJacketing: (data) =>
        axiosInstance.post(
            '/api/common/getProductJacketing',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductUsage: (data) =>
        axiosInstance.post(
            '/api/common/getProductUsage',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductColor: (data) =>
        axiosInstance.post(
            '/api/common/getProductColor',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductWhiteLabeling: (data) =>
        axiosInstance.post(
            '/api/common/getProductWhiteLabeling',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductPackingUnit: (data) =>
        axiosInstance.post(
            '/api/common/getProductPackingUnit',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getCutPieceReason: (data) =>
        axiosInstance.post(
            '/api/common/getCutPieceReason',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),

    getMachineNo: (data) =>
        axiosInstance.post(
            '/api/common/getMachineNo',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getShift: (data) =>
        axiosInstance.post(
            '/api/common/getShift',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getShiftIncharge: (data) =>
        axiosInstance.post(
            '/api/common/getShiftIncharge',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getMachineOperator: (data) =>
        axiosInstance.post(
            '/api/common/getMachineOperator',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductPackingUnitLength: (data) =>
        axiosInstance.post(
            '/api/common/getProductPackingUnitLength',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductLengthMarking: (data) =>
        axiosInstance.post(
            '/api/common/getProductLengthMarking',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductVariants: (data) =>
        axiosInstance.post(
            '/api/common/getProductVariants',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductPackagingVariants: (data) =>
        axiosInstance.post(
            '/api/common/getProductPackagingVariants',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductArticle: (data) =>
        axiosInstance.post(
            '/api/common/getProductArticle',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSizes: (data) =>
        axiosInstance.post(
            '/api/common/getProductSizes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductTiers: (data) =>
        axiosInstance.post(
            '/api/common/getProductTiers',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductGrades: (data) =>
        axiosInstance.post(
            '/api/common/getProductGrades',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPurchaseAccounts: (data) =>
        axiosInstance.post(
            '/api/common/getPurchaseAccounts',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRoles: (data) =>
        axiosInstance.post(
            '/api/common/getRoles',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountingPeriods: (data) =>
        axiosInstance.post(
            '/api/common/getAccountingPeriods',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getControlAccounts: (data) =>
        axiosInstance.post(
            '/api/common/getControlAccounts',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getControlGeographical: (data) =>
        axiosInstance.post(
            '/api/common/getControlGeographical',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),

    getControlSalesDesignation: (data) =>
        axiosInstance.post(
            '/api/common/getControlSalesDesignation',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),

    getControlAccountSequenceNo: (data) =>
        axiosInstance.post(
            '/api/common/getControlAccountSequenceNo',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountTypes: (data) =>
        axiosInstance.post(
            '/api/common/getAccountTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyByParams: (data) =>
        axiosInstance.post(
            '/api/common/getPartyByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getSecondaryPartyByParams: (data) =>
        axiosInstance.post(
            '/api/common/getSecondaryPartyByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductionOrderProducts: (data) =>
        axiosInstance.post(
            '/api/common/getProductionOrderProducts',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountByParams: (data) =>
        axiosInstance.post(
            '/api/common/getAccountByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCombineAccountsView: (data) =>
        axiosInstance.post(
            '/api/common/getCombineAccountsView',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherTypeDependencies: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherTypeDependencies',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductRowRack: (data) =>
        axiosInstance.post(
            '/api/common/getProductRowRack',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getIsUserSalesman: (data) =>
        axiosInstance.post(
            '/api/common/getIsUserSalesman',
            {
                user_id: AuthService.getActiveUserId(),
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getWarehouse: (data) =>
        axiosInstance.post(
            '/api/common/getWarehouse',
            {
                branch_id: AuthService.getActiveBranchId(),
                user_id: AuthService.getActiveUserId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductProductionLine: (data) =>
        axiosInstance.post(
            '/api/common/getProductProductionLine',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountsGroupMapping: (data) =>
        axiosInstance.post(
            '/api/common/getAccountsGroupMapping',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductByParams: (data) =>
        axiosInstance.post(
            '/api/common/getProductByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountGroupMappingByParams: (data) =>
        axiosInstance.post(
            '/api/common/getAccountGroupMappingByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductSalesDiscount: (data) =>
        axiosInstance.post(
            '/api/common/getProductSalesDiscount',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentSalesDiscountPolicy: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentSalesDiscountPolicy',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getLastProductProductionHistory: (data) =>
        axiosInstance.post(
            '/api/common/getLastProductProductionHistory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getLastFinishedProductProductionHistory: (data) =>
        axiosInstance.post(
            '/api/common/getLastFinishedProductProductionHistory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterialDetailForRawProduction: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterialDetailForRawProduction',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterialDetailForFinishedProduction: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterialDetailForFinishedProduction',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentFinishedProductBillOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentFinishedProductBillOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentCompositionOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentCompositionOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentCompositionOfMaterialDetail: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentCompositionOfMaterialDetail',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getRowRackByParams: (data) =>
        axiosInstance.post(
            '/api/common/getRowRackByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),

    getHistoryParams: (data) =>
        axiosInstance.post(
            '/api/common/getHistoryParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherDetailAudit: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherDetailAudit',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherDetailMaster: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherDetailMaster',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getGeneralAccountMapping: (data) =>
        axiosInstance.post(
            '/api/common/getGeneralAccountMapping',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getApprovalStageParams: (data) =>
        axiosInstance.post(
            '/api/common/getApprovalStageParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getSalesInvoiceRegularDetailByWarehouse: (data) =>
        axiosInstance.post(
            '/api/common/getSalesInvoiceRegularDetailByWarehouse',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    updateSalesInvoiceRegularDeliveryStatus: (data) =>
        axiosInstance.post(
            '/api/common/updateSalesInvoiceRegularDeliveryStatus',
            {
                branch_id: AuthService.getActiveBranchId(),
                user_id: AuthService.getActiveUserId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        )
};
